package one.devsbox.www.ui.apps

import androidx.compose.foundation.text.input.TextFieldState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import kotlinx.coroutines.launch
import compose.assets.Svg
import compose.assets.svg.Plus
import one.devsbox.shared.ads.SharedIO
import one.devsbox.shared.devices.IO
import one.devsbox.www.io.Repository
import one.devsbox.www.ui.widgets.ScreenContentAction
import one.devsbox.www.tools.ArgsId
import one.devsbox.www.tools.ArgsIdWithParent
import one.devsbox.www.www_portal.generated.resources.*
import org.jetbrains.compose.resources.getString
import tk.mallumo.compose.navigation.navTo_AppWheelDUI
import tk.mallumo.compose.navigation.navTo_AppWheelEUI
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.utils.DataState

@VM
class ListingAppsVM : NavigationViewModel() {
    private lateinit var ctx: ListingAppsCtx

    var contentActions by mutableStateOf<List<ScreenContentAction>>(emptyList())
        private set

    var state by mutableStateOf<DataState<SharedIO.AppInstancies>>(DataState.Loading())
        private set

    var loadingMore by mutableStateOf(false)
        private set

    val search = TextFieldState()

    var wwwApps by mutableStateOf<List<IO.Application>>(emptyList())
        private set

    var showAppPickerDialog by mutableStateOf(false)

    interface Action {
        fun loadMore()
        fun reload()
        fun openDetail(appInstance: SharedIO.AppInstanceSimple)
        fun createNew(appId: Long)
        fun back()
    }

    val action = object : Action {
        override fun loadMore() {
            val currentState = state
            if (currentState is DataState.Result && !loadingMore && currentState.nnvl.items.size < currentState.nnvl.count) {
                fetchApps(page = currentState.nnvl.page + 1)
            }
        }

        override fun reload() {
            fetchApps(0)
        }

        override fun openDetail(appInstance: SharedIO.AppInstanceSimple) {
            ctx.nav.navTo_AppWheelDUI(ArgsId(appInstance.id))
        }

        override fun createNew(appId: Long) {
            showAppPickerDialog = false
            ctx.nav.navTo_AppWheelEUI(ArgsIdWithParent(-1L, appId))
        }

        override fun back() {
            ctx.nav.up()
        }
    }

    fun setup(ctx: ListingAppsCtx) {
        this.ctx = ctx
        fetchApps(0)
    }

    private fun fetchApps(page: Int) {
        if (page == 0) {
            state = DataState.Loading()
            wwwApps = emptyList()
        } else {
            loadingMore = true
        }

        scope.launch {
            try {
                if (page == 0) {
                    wwwApps = Repository.ads.app.listingWww()
                }
                val response = Repository.ads.app.instance.listing(page)
                if (page == 0) {
                    state = DataState.Result(response)
                } else {
                    val current = (state as? DataState.Result)?.nnvl
                    if (current != null) {
                        state = DataState.Result(
                            current.copy(
                                page = response.page,
                                items = current.items + response.items
                            )
                        )
                    }
                }
                loadingMore = false
                setupActions()
            } catch (it: Throwable) {
                if (page == 0) {
                    val fallbackError = try {
                        getString(Res.string.ui_error_unknown)
                    } catch (e: Throwable) {
                        "Unknown error"
                    }
                    state = DataState.Error(it.message ?: fallbackError)
                }
                loadingMore = false
                contentActions = emptyList()
            }
        }
    }

    private fun setupActions() {
        contentActions = buildList {
            val eligibleWwwApps = wwwApps.filter { it.type != 8 }
            if (ctx.me.permission.application.write && !ctx.me.info.adminMode && eligibleWwwApps.isNotEmpty()) {
                add(
                    ScreenContentAction(
                        text = Res.string.apps,
                        color = ctx.colorPrimaryContainer,
                        icon = Svg.Plus
                    ) {
                        showAppPickerDialog = true
                    }
                )
            }
        }
    }

    override fun onRelease() {}
}
